/**
 * Enum with supported lock ids.
 * To be extended with new lock ids if new operations will be supported.
 *
 * Always use a prefix to avoid naming collisions with other locks.
 */
export const LockId = {
  picoXSendEvents: 'picoXSendEvents',
} as const;

/**
 * Callback to be executed with a lock.
 */
//eslint-disable-next-line @typescript-eslint/no-empty-function
export type LockCallbackType = () => Promise<void>;

/**
 * Run a callback with a lock to avoid concurrent activities by multiple instances.
 */
export type LockRunner = (lockId: keyof typeof LockId, callback: LockCallbackType) => Promise<void>;

/**
 * A log used to synchronize the execution of a callback across tabs, the tab that acquires the lock will execute the callback.
 * The lock will be released when the tab is closed.
 */
export const webLockApiRunner = (): LockRunner => {
  return async (lockId, callback) => {
    window.navigator.locks.request(lockId, async () => {
      await callback();

      // The lock will only be released when the tab is closed.
      //eslint-disable-next-line @typescript-eslint/no-empty-function
      return new Promise(() => {});
    });
  };
};
